import axios from "axios";
import { SERVER_URL } from "../config";
import { history } from "../helpers";
import { authHeader, handleError, handleResponse } from "../helpers";

let baseRoute = SERVER_URL;

export const homeService = {
    getReportE_commerce,
    getAllEmployerUserList,
};

function getReportE_commerce(mobileOrEmail, password) {
    console.log("into homeService (getReportE_commerce)");
    return axios
        .get(`${baseRoute}/report/e-commerce`, { headers: authHeader(), })
        .then((res) => {
            return res.data;
        })
        .catch(function (error) {
            if (error.response) {
                console.log(error.response.data);
                handleError(error.response.status);
            }
        });
}


function getAllEmployerUserList() {
    console.log("into homeService (getAllEmployerUserList)");
    
    return axios
        .get(`${baseRoute}/user/list`, { headers: authHeader(), })
        .then((res) => {
            return handleResponse(res);
        })
        .catch(function (error) {
            if (error.response) {
                console.log(error.response.data);
                handleError(error.response.status);
            }
        });
}
